import React from "react";

import { assetImg } from "@/modules/moduleImporter";
import { renderResultHistory } from "@/modules/commonPopupResultHistory";
import { IPopupResultHistoryProps } from "@/types/PopupResultHistoryTypes";

import "../index.scss";
import { getBasePcode } from "@/modules/gamePcode";

//NiuNiu
export default class M24 extends React.PureComponent<IPopupResultHistoryProps> {
	/*
	"history": [
		{
			"dealer": "5c-Ah-Jc-Ad-2h",
			"player1": "Qc-4h-Td-Ks-4c",
			"player2": "9d-4s-7s-Qs-Qh",
			"player3": "3d-Qd-2s-5d-7c",
			"result": "player1,player2,player3",
			"valuedealer": "nobul",
			"valueplayer1": "bull8",
			"valueplayer2": "bull0",
			"valueplayer3": "bull7"
		}
	] */
	
	render() {
		// Template consts
		const langdata = this.props.langdata,
			orientation = this.props.orientation;

		const basePcode = getBasePcode(this.props.activeGame.pcode);
		
		const tabNames = ["Banker & Player 1", "Player 2 & Player 3"];

		// HEADERS
		const landscapeHeaders = [
			langdata["txt_periode"],
			langdata["txt_banker"],
			"Score",
			
			`${langdata["txt_player"]} 1`,
			"Score",
			
			`${langdata["txt_player"]} 2`,
			"Score",
			
			`${langdata["txt_player"]} 3`,
			"Score",
		];
		
		const portraitHeaderIndices = (
			this.props.portraitTabIndex === 0 ? [0, 1, 2, 3, 4] : [0, 5, 6, 7, 8]
		);
		
		// PROCESS HISTORY HERE
		const bodyMapFunction = (item, idx) => {
			const cells = [
				item.periode,
				
				...["dealer", "dealer",
					"player1", "player1",
					"player2", "player2",
					"player3", "player3"].map((playerName, _idx) =>
						!(_idx % 2) ?
						item[playerName].split("-").map(
							(card, cardIdx) =>
							assetImg("baccarat", card, `m24PRH_${card}_${cardIdx}`)
						) : (() => {
							const lastLetter = item["value" + playerName]
								[item["value" + playerName].length - 1];

							return (
								<div className={item.result.indexOf(playerName) >= 0 ? "bg-green" : ""}>
								{
									item["value" + playerName] === "nobul" ? "NB" :
									item["value" + playerName] === "gong" ? "BB" :
									lastLetter === "0" ? "BB" : lastLetter
								}
								</div>
							);
						})()
				),
			];
			
			
			
			//Template functions start here
			const landscapeColumns = cells.map((cell, _idx) =>
				<td key={"lC_" + _idx}>
					{cell}
				</td>
			), portraitColumns = portraitHeaderIndices.map((num, _idx) =>
				<td key={"pC_" + this.props.portraitTabIndex + _idx}>
					{ cells[num] }
				</td>
			);
		
			return (
				<tr key={"tpdhm_" + idx}>
					{
						orientation === "landscape" ?
						landscapeColumns : portraitColumns
					}
				</tr>
			);
		};
		
		

		// Template Tab Headers, no need to change
		const headers = orientation === "landscape" ?
			landscapeHeaders :
			portraitHeaderIndices.map(num => landscapeHeaders[num]);

		// Template function, no need to change
		return renderResultHistory(
			this.props.activeGame.resultHistory,
			basePcode,
			headers,
			bodyMapFunction,
			
			this.props.gameResultHistoryPage,

			this.props.fetchResultHistory,
			this.props.changePortraitResultHistoryTab,
			
			{
				mobile: this.props.mobile,
				mobileHome: this.props.mobileHome,
				desktop: this.props.desktop,
				orientation: orientation,
				tabNames: tabNames,
				
				portraitTabIndex: this.props.portraitTabIndex,
				showGameResultHistoryLoadingOverlay: this.props.showGameResultHistoryLoadingOverlay
			}
		);
	}
}
